/**
 * GroundTruthRef — a pointer to a ground truth value that a grader
 * resolves at scoring time. Deliberately decoupled from the Task so
 * GT data can drift independently of test definitions.
 *
 * The `source` field selects the resolver backend:
 *   - "gt-set-v1": adapter over the existing GroundTruth table (no migration)
 *   - future: "s3", "api", "inline" etc.
 *
 * The `key` is opaque to the harness — the resolver interprets it
 * (for gt-set-v1, it's the GroundTruth row id).
 *
 * The optional `field` lets a grader request a specific sub-path
 * (e.g., "expectedOutput.disposition") rather than the full GT value.
 *
 * The optional `version` pins to a specific GT version so the Task
 * can be run reproducibly even as the reference data evolves.
 */
import { z } from 'zod';
export const GroundTruthRefSchema = z.object({
    /** Resolver backend identifier (e.g., "gt-set-v1"). */
    source: z.string().min(1),
    /** Key within that source (e.g., GroundTruth row id). */
    key: z.string().min(1),
    /** Optional: extract a specific field from the resolved value (dot-path). */
    field: z.string().optional(),
    /** Optional: pin to a specific GT version for reproducibility. */
    version: z.string().optional(),
});
//# sourceMappingURL=ground-truth-ref.js.map